import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  TextField,
  IconButton,
  Typography,
  Grid,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

const ImageEntryList = (props) => {
  const handleFileChange = (index, file) => {
    const updated = [...props.entries];
    updated[index].file = file;
    updated[index].previewUrl = file ? URL.createObjectURL(file) : undefined;
    props.setEntries(updated);
  };

  const handleDescriptionChange = (index, description) => {
    const updated = [...props.entries];
    updated[index].description = description;
    props.setEntries(updated);
  };

  const addEntry = () => {
    props.setEntries([...props.entries, { file: null, description: "" }]);
  };

  const removeEntry = (index) => {
    const updated = props.entries.filter((_, i) => i !== index);
    props.setEntries(updated);
  };

  //const moveEntryUp = (index) => {
  //  if (index === 0) return;
  //  const updated = [...props.entries];
  //  [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];
  //  props.setEntries(updated);
  //};

  //const moveEntryDown = (index) => {
  //  if (index === props.entries.length - 1) return;
  //  const updated = [...props.entries];
  //  [updated[index + 1], updated[index]] = [updated[index], updated[index + 1]];
  //  props.setEntries(updated);
  //};

  return (
    <Grid container spacing={2}>
      {props.entries.map((entry, index) => (
        <Grid item size={{ xs: 12 }} key={index}>
          <Card
            variant="outlined"
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              backgroundColor: "white",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease",
              "&:hover": {
                boxShadow: "0 8px 24px rgba(102, 126, 234, 0.15)",
                transform: "translateY(-4px)",
              },
            }}
          >
            {entry.previewUrl && (
              <CardMedia
                component="img"
                image={entry.previewUrl}
                alt="Vorschau"
                sx={{
                  height: 200,
                  objectFit: "contain",
                  backgroundColor: "#ffffffff",
                  marginTop: "5px",
                  borderRadius: "8px",
                }}
              />
            )}
            <CardContent sx={{ flexGrow: 1 }}>
              <Box display="flex" flexDirection="column" gap={2}>
                {!entry.previewUrl && (
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      handleFileChange(index, e.target.files?.[0] || null)
                    }
                  />
                )}
                <TextField
                  label="Beschreibung"
                  variant="outlined"
                  size="small"
                  value={entry.description}
                  onChange={(e) =>
                    handleDescriptionChange(index, e.target.value)
                  }
                  inputProps={{ maxLength: 200 }}
                />
              </Box>
            </CardContent>

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                px: 2,
                pb: 1,
                gap: 1,
              }}
            >
              <IconButton
                aria-label="Löschen"
                onClick={() => removeEntry(index)}
                sx={{ color: "grey" }}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          </Card>
        </Grid>
      ))}

      <Grid item size={{ xs: 12 }}>
        <Box
          onClick={addEntry}
          sx={{
            height: 200,
            border: "2px dashed #667eea",
            backgroundColor: "rgba(102, 126, 234, 0.05)",
            borderRadius: "12px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "rgba(102, 126, 234, 0.1)",
              borderColor: "#764ba2",
              transform: "translateY(-4px)",
              boxShadow: "0 8px 24px rgba(102, 126, 234, 0.2)",
            },
          }}
        >
          <AddIcon fontSize="large" sx={{ color: "#667eea" }} />
          <Typography
            variant="body1"
            sx={{ color: "#667eea", fontWeight: 600 }}
          >
            Foto hinzufügen
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ImageEntryList;
